import { useCallback, type FC } from "react";
import { TriggerTypeSelect } from "@/components/automations/TriggerTypeSelect";
import { type WorkflowEditFormTriggerData } from "@/components/automations/automation-edit-form-data";
import { WorkflowEditTriggerConfiguration } from "@/components/automations/AutomationEditTriggerConfiguration";
import type { PlainWorkflow } from "@/queries/automation-queries";

type WorkflowEditTriggerItemProps = {
    workflow: PlainWorkflow;
    trigger: WorkflowEditFormTriggerData;
    onUpdate: (trigger: WorkflowEditFormTriggerData) => void;
    disabled?: boolean;
};

export const WorkflowEditTriggerItem: FC<WorkflowEditTriggerItemProps> = ({
    workflow,
    trigger,
    onUpdate,
    disabled = false,
}) => {
    const handleTypeChange = useCallback(
        (newType: WorkflowEditFormTriggerData["type"]) => {
            const updatedTrigger: WorkflowEditFormTriggerData = {
                ...trigger,
                type: newType,
                config: {
                    time: newType === "time" ? { cronExpression: "" } : undefined,
                    pullRequest: newType === "pullRequest" ? { events: [] } : undefined,
                },
            };
            onUpdate(updatedTrigger);
        },
        [trigger, onUpdate],
    );

    const handleConfigChange = useCallback(
        (updatedTrigger: WorkflowEditFormTriggerData) => {
            onUpdate(updatedTrigger);
        },
        [onUpdate],
    );

    return (
        <div className="flex flex-col gap-3">
            <TriggerTypeSelect value={trigger.type} onChange={handleTypeChange} disabled={disabled} />
            <WorkflowEditTriggerConfiguration
                workflow={workflow}
                trigger={trigger}
                disabled={disabled}
                handleConfigChange={handleConfigChange}
            />
        </div>
    );
};
